module.exports = __webpack_public_path__ + "img/edit icon.8138d774.svg";